import React, { useState, useEffect, useRef } from 'react';
import { TextField, FormHelperText } from '@mui/material';
import { validateSQL, DANGEROUS_OPERATORS_LIST } from 'helpers/sqlValidation';

const SQLFilter = ({ value, onChange, onValidationErrorChange, columnName }) => {
  const [validationError, setValidationError] = useState(false);
  const [errorType, setErrorType] = useState(null);
  const previousErrorState = useRef(false);

  const handleChange = (value) => {
    const validation = validateSQL(value, {
      columnName,
      requireColumnName: true
    });
    
    setValidationError(!validation.isValid);
    setErrorType(validation.errorType);
    
    if (onValidationErrorChange) {
      onValidationErrorChange(!validation.isValid);
    }
    
    onChange(value, 'sql');
  };

  useEffect(() => {
    const validation = validateSQL(value, {
      columnName,
      requireColumnName: true
    });
    
    const isValid = validation.isValid;
    const newErrorState = !isValid;
    
    // Only update state and call the callback if the error state has changed
    if (previousErrorState.current !== newErrorState) {
      setValidationError(newErrorState);
      setErrorType(validation.errorType);
      
      if (onValidationErrorChange) {
        onValidationErrorChange(newErrorState);
      }
      
      previousErrorState.current = newErrorState;
    }
  }, [value, columnName, onValidationErrorChange]);

  const getErrorMessage = () => {
    if (errorType === 'empty') {
      return "This field is required";
    } else if (errorType === 'missingColumn') {
      return `Filter must include the column name (${columnName})`;
    } else if (errorType === 'disallowedOperator') {
      return `SQL contains potentially dangerous operators: ${DANGEROUS_OPERATORS_LIST.join(", ")}`;
    } else if (errorType === 'syntaxError') {
      return `Invalid SQL syntax: Please check your query for errors`;
    }
    return "";
  };

  return (
    <>
      <TextField
        value={value}
        onChange={(e) => handleChange(e.target.value)}
        placeholder={`Enter SQL WHERE filter. You must reference the column name (${columnName}) in your filter (e.g., \`${columnName} >= 18\`).`}
        fullWidth
        size="small"
        sx={{ mt: 1 }}
        error={validationError}
      />
      {validationError && (
        <FormHelperText error>
          {getErrorMessage()}
        </FormHelperText>
      )}
    </>
  );
};

export default SQLFilter; 